import ActivateScreen from "../screens/Activation";
import FireBoard from "../screens/Fireboard";
import TMS from "../screens/TMS";
import AppLoading from "../screens/AppLoading";
import Diagnostics from "../screens/Diagnostics";
import Login from "../screens/Login";
import FireboardPreAuth from "../screens/FireboardPreAuth";
import Playground from '../screens/Playground';
import KitchenApp from "../screens/KitchenApp";
import ServerAppLogin from "../screens/ServerAppLogin";
import TeamShare from "../screens/TeamShare";
import Receipt from '../screens/Receipt';
import PrintServer from '../screens/PrintServer';
import TableMerge from '../screens/TableMerge';
import EmployeeAssignment from '../screens/EmployeeAssignment';
import TableSensors from "../screens/TableSensors";
import NamedSensors from "../screens/NamedSensors";
import StoreCubby from "../screens/StoreCubby";
import OrderStatusManager from '../screens/OrderStatusManager';
import TableDelivery from '../screens/TableDelivery';
import OutOfStock from "../screens/OutOfStock";
import EmployeeSectionAssignment from "../screens/EmployeeSectionAssignment";
import Dashboard from '../screens/Dashboard';
import Waitlist from "../screens/WaitList";

const routes = [
  {
    path: "/activate",
    component: ActivateScreen,
  },
  {
    path: "/fireboard",
    component: FireBoard,
  },
  {
    path: "/printRequests",
    component: PrintServer,
  },
  {
    path: "/tms",
    component: Waitlist,
  },
  {
    path: "/kitchen",
    component: KitchenApp,
  },
  {
    path: "/diagnostics",
    component: Diagnostics,
  },
  {
    path: "/fireboardPreAuth",
    component: FireboardPreAuth,
  },
  {
    path: "/managerLogin",
    component: Login,
  },
  {
    path: "/playground",
    component: Playground,
  },
  {
    path: "/serverApp",
    component: ServerAppLogin,
  },
  {
    path: "/teamShare",
    component: TeamShare,
  },
  {
    path: "/receipt",
    component: Receipt,
  },
  {
    path: '/tableMerge',
    component: TableMerge,
  },
  {
    path: '/employeeAssignment',
    component: EmployeeAssignment,
  },
  {
    path: '/employeeSectionAssignment',
    component: EmployeeSectionAssignment,
  },
  {
    path: '/tableSensors',
    component: TableSensors,
  },
  {
    path: '/namedSensors',
    component: NamedSensors,
  },
  {
    path: '/cubbyManager',
    component: StoreCubby,
  },
  {
    path: '/orderStatusManager',
    component: OrderStatusManager,
  },
  {
    path: '/tableDelivery',
    component: TableDelivery,
  },
  {
    path: '/gpsLocationDelivery',
    component: TableDelivery,
  },
  {
    path: '/dashboard',
    component: Dashboard,
  },
  {
    path: '/outOfStock/:menuType',
    component: OutOfStock,
  },
  {
    path: "/activationCode/:externalId",
    component: AppLoading,
  },
  {
    path: "/",
    component: AppLoading,
  },
];

export default routes;
